import React from "react";
import Layout from "../Layout";
import { Grid } from "@mui/material";
import CrossProductsPage from "../../../widgets/management/scripts/CrossProduct/CrossProduct";

function Scripts(props) {
  return (
    <Layout>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <CrossProductsPage />
      </Grid>
    </Layout>
  );
}

export default Scripts;
